import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import currencyFormatter from "currency-formatter";

import OfferitemListService from "../_services/offer/OfferitemListService";
import {Dialog} from "primereact/dialog";
import OfferitemFormComponent from "./OfferitemFormComponent";
import OfferitemDeleteService from "../_services/offer/OfferitemDeleteService";
import OfferitemProductListComponent from "./OfferitemProductListComponent";
import OfferitemPricelistitemListComponent from "./OfferitemPricelistitemListComponent";

const OfferitemListComponent = (props) => {

  const [offeritem, setOfferitem] = useState([]);
  const [formData, setFormData] = useState({});

  const [sumNet, setSumNet] = useState(0);
  const [sumVat, setSumVat] = useState(0);
  const [sumBr, setSumBr] = useState(0);

  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'name',
    sortOrder: -1
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderOfferitemList: false})
      OfferitemListService(props.initialValues.id, JSON.stringify(lazyParams))
        .then(response => {
          setTotalRecords(response.data.total_item_count);
          setOfferitem(response.data.items);
          setLoading(false);
          let netSum = 0
          let vatSum = 0
          let brSum = 0
          response.data.items.map((item) => {
            netSum = netSum + item.netAmount
            vatSum = vatSum + item.vatAmount
            brSum = brSum + item.grossAmount
          })
          setSumNet(netSum)
          setSumVat(vatSum)
          setSumBr(brSum)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const deleteOfferitem = (rowData) => {
    OfferitemDeleteService(props.initialValues.id, rowData.id)
      .then(response => {
        window.App.toastShow('success', 'Sikeres törlés!',);
        loadLazyData();
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {props && props.initialValues && props.initialValues.status === 'DRAFT' &&
        <>
          {/*{localStorage.getItem('roles').toString().includes('role_offeritem_write') &&*/}
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip="Módosítás" tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    window.App.setState({
                      dialogOfferitemUpdate: true,
                      offerItemRowData: rowData
                    })
                  }}/>
          {/*}*/}
          {/*{localStorage.getItem('roles').toString().includes('role_offeritem_write') &&*/}
          <Button icon="pi pi-trash" className="  p-button-danger p-mr-2"
                  tooltip="Törlés" tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      deleteOfferitem(rowData)
                    }
                  }}
          />
          {/*}*/}
        </>
        }
      </React.Fragment>
    );
  }

  const [expandedRows, setExpandedRows] = useState(null);
  const rowExpansionTemplate = (data) => {
    return (
      <>
        <div className="p-ml-3">
          <h3 className={"p-mt-0 p-pt-0"}>Szolgáltatások</h3>
          <OfferitemPricelistitemListComponent itemId={data.id}/>
          <h3 className={"p-mt-0 p-pt-0"}>Termékek vagy alapanyagok</h3>
          <OfferitemProductListComponent itemId={data.id}/>
        </div>
      </>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderOfferitemList === true])

  return (

    <>
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage="Nincs találat."
        value={offeritem} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        stripedRows
        selectionMode="checkbox"
        dataKey="id"
        filterDisplay="row"
        responsiveLayout="scroll"
        rowExpansionTemplate={rowExpansionTemplate}
        expandedRows={expandedRows}
        onRowExpand={(e) => {
          let id = e.data.id
          setExpandedRows({[id]: true})
          window.App.setState({
            offerItemRowData: e.data
          })
        }}
        onRowCollapse={() => {
          setExpandedRows({})
        }}
      >
        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
        <Column field="externalReference" header="Külső hivatkozás" sortable filter
                filterPlaceholder="Külső hivatkozás"></Column>
        <Column field="netAmount" header="Nettó érték" className={"p-text-right p-text-nowrap"}
                alignHeader="right"
                body={(rowData) => {
                  let currency
                  if (formData.currency === 'HUF') {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: ',',
                      thousand: ' ',
                    }
                  } else {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: '.',
                      thousand: ' ',
                    }
                  }
                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.netAmount, {
                          precision: currency.precision,
                          symbol: currency.symbol,
                          decimal: currency.decimal,
                          thousand: currency.thousand,
                        }
                      )
                      }
                      &nbsp;{formData.currency}
                    </>
                  )
                }}></Column>
        <Column field="vatAmount" header="ÁFA" className={"p-text-right p-text-nowrap"}
                alignHeader="right"
                body={(rowData) => {
                  let currency
                  if (formData.currency === 'HUF') {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: ',',
                      thousand: ' ',
                    }
                  } else {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: '.',
                      thousand: ' ',
                    }
                  }
                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.vatAmount, {
                          precision: currency.precision,
                          symbol: currency.symbol,
                          decimal: currency.decimal,
                          thousand: currency.thousand,
                        }
                      )
                      }
                      &nbsp;{formData.currency}
                    </>
                  )
                }}></Column>
        <Column field="grossAmount" header="Bruttó érték" className={"p-text-right p-text-nowrap"}
                alignHeader="right"
                body={(rowData) => {
                  let currency
                  if (formData.currency === 'HUF') {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: ',',
                      thousand: ' ',
                    }
                  } else {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: '.',
                      thousand: ' ',
                    }
                  }
                  return (
                    <>
                      {currencyFormatter.format(
                        rowData.grossAmount, {
                          precision: currency.precision,
                          symbol: currency.symbol,
                          decimal: currency.decimal,
                          thousand: currency.thousand,
                        }
                      )
                      }
                      &nbsp;{formData.currency}
                    </>
                  )
                }}></Column>
        <Column field="quantity" header="Mennyiség" className={"p-text-right"} alignHeader="right" body={(rowData) => {
          return (
            <>
              {rowData.quantity} {rowData.unitName}
            </>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
        <Column expander style={{width: '3em'}}/>
      </DataTable>
      <div className={"p-grid p-mt-1"}>
        <div className={"p-col-12 p-lg-6"}>

        </div>
        <div className={"p-col-12 p-lg-6 p-text-right"}>
          {props && props.initialValues && props.initialValues.status === 'DRAFT' ? (
            <>
              <Button type="button" label="Tétel hozzáadása" icon="pi pi-plus" className="p-button-success  p-ml-2"
                      onClick={() => {
                        window.App.setState({
                          dialogOfferitemCreate: true,
                        })
                      }}
              />
            </>
          ) : (
            <>
              <Button type="button" label="Tétel hozzáadása" icon="pi pi-plus"
                      disabled className="p-button-success  p-ml-2"
              />
            </>
          )}
          <Dialog visible={window.App.state.dialogOfferitemUpdate}
                  style={{width: '750px'}}
                  header="Tétel módosítása"
                  modal
                  onHide={() => {
                    window.App.setState({
                      dialogOfferitemUpdate: false
                    })
                  }}>
            <OfferitemFormComponent offerId={window.App.state.props.id}
                                    initialValues={window.App.state.offerItemRowData}/>
          </Dialog>
          <Dialog visible={window.App.state.dialogOfferitemCreate}
                  style={{width: '750px'}}
                  header="Tétel hozzáadása"
                  modal
                  onHide={() => {
                    window.App.setState({
                      dialogOfferitemCreate: false
                    })
                  }}>
            <OfferitemFormComponent offerId={window.App.state.props.id}/>
          </Dialog>
        </div>
      </div>

      <div className={"p-grid p-mt-1"}>
        <div className={"p-col-12 p-lg-8"}>

        </div>
        <div className={"p-col-12 p-lg-4"}>
          <>
            <hr/>
            <div className={"p-grid"}>
              <div className={"p-col p-text-right"}>
                Nettó összesen:
              </div>
              <div className={"p-col p-text-right"}>
                {currencyFormatter.format(
                  sumNet, {
                    precision: 2,
                    symbol: '',
                    decimal: ',',
                    thousand: ' ',
                  }
                )}&nbsp;{window.App.state.props.currency}
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col p-text-right"}>
                ÁFA összesen:
              </div>
              <div className={"p-col p-text-right"}>
                {currencyFormatter.format(
                  sumVat, {
                    precision: 2,
                    symbol: '',
                    decimal: ',',
                    thousand: ' ',
                  }
                )}&nbsp;{window.App.state.props.currency}
              </div>
            </div>
            <div className={"p-grid"}>
              <div className={"p-col p-text-right"}>
                Bruttó összesen:
              </div>
              <div className={"p-col p-text-right"}>
                {currencyFormatter.format(
                  sumBr, {
                    precision: 2,
                    symbol: '',
                    decimal: ',',
                    thousand: ' ',
                  }
                )}&nbsp;{window.App.state.props.currency}
              </div>
            </div>
            <hr/>
          </>
        </div>
      </div>

    </>

  )
}
export default withTranslation('common')(OfferitemListComponent);
